import auth from "@/server/api/auth.js";
import COS from "cos-js-sdk-v5";
var Bucket; /* 存储桶，必须字段 */
var Region; /* 存储桶所在地域，必须字段 */
var sessionToken;
// import uuid from "uuid-js";
import { fetchEndpoint } from "@/server/network";

export const uploadAttachment = function (file, rate) {
  return new Promise((resolve) => {
    let options = {
      pathDir: "/saas",
    };
    if (!options.pathDir) {
      options.pathDir = "/saas";
    }
    sessionStorage.setItem(rate, "0");
    console.log(file);
    if (!file.fromArticle) {
      file.fromArticle = false;
    }
    // return;
    let _name = file.name;
    if (_name.indexOf(".") == -1) {
      _name += ".";
    }
    let format = _name.split(".").splice(-1, 1)[0];
    //   let FILENAME = uuid.create() + "." + format;
    let time_now = new Date();
    let FILENAME =
      _name.substring(0, _name.lastIndexOf(".")) +
      "_" +
      parseInt(time_now.getTime() / 1000) +
      "." +
      format;
    console.log("文件名", FILENAME);
    let str = "";
    // let types = file.type;
    auth.setting().then(
      (res) => {
        console.log("返回的参数", res);
        // return;
        if (res && res.code === 0) {
          sessionToken = res.data.COS.credentials.sessionToken;
          let credential = {
            TmpSecretId: res.data.COS.credentials.tmpSecretId,
            TmpSecretKey: res.data.COS.credentials.tmpSecretKey,
            SecurityToken: res.data.COS.credentials.sessionToken,
            // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
            StartTime: Math.round(res.data.COS.startTime / 1000), // 时间戳，单位秒，如：1580000000
            ExpiredTime: Math.round(res.data.COS.expiredTime / 1000),
          };
          // console.log("参数", JSON.parse(JSON.stringify(credential)));
          let file_name = options.pathDir;
          let month = time_now.getMonth() + 1;

          if (file.type.indexOf("video") == -1) {
            file_name +=
              "/attachment/" +
              time_now.getFullYear() +
              "-" +
              (month < 10 ? "0" + month : month) +
              "/" +
              FILENAME;
          } else if (file.type.indexOf("video") != -1) {
            //分块上传的key需要和之前保持一致
            str = file.name + file.lastModified + file.size + file.type;
            if (!localStorage[str]) {
              localStorage[str] = FILENAME;
            } else {
              console.log("使用上次的uuid", localStorage[str]);
              FILENAME = localStorage[str];
            }
            file_name +=
              "/attachment/" +
              time_now.getFullYear() +
              "-" +
              (month < 10 ? "0" + month : month) +
              "/" +
              FILENAME;
          }
          //   let file_name = FILENAME;
          // console.log('credential', credential)
          let cos = new COS({
            // getAuthorization 必选参数
            getAuthorization: function (options, callback) {
              callback(credential);
            },
          });
          if (res.data) {
            // console.log(res.data);
            Bucket = res.data.TENCENT_COS_BUCKET;
            Region = res.data.TENCENT_COS_REGION;
          }
          // cos.headObject(
          //   {
          //     Bucket,
          //     Region,
          //     Key: file_name /* 必须 */,
          //   },
          //   function (exist_err, exist_data) {
          //     console.log("exist_err", exist_err);
          //     console.log("exist_data", exist_data);
          //   }
          // );
          // return;
          //视频上传使用分块上传
          if (file.type.indexOf("video") != -1) {
            cos.sliceUploadFile(
              {
                Bucket /* 必须 */,
                Region /* 存储桶所在地域，必须字段 */,
                Key: file_name /* 必须 */,
                // StorageClass: 'STANDARD',
                Body: file, // 上传文件对象
                onTaskReady: function (taskId) {
                  /* 非必须 */
                  console.log("任务id", taskId);
                },
                onHashProgress: function (progressData) {
                  /* 非必须 */
                  console.log("md5计算", JSON.stringify(progressData));
                },
                onProgress: function (progressData) {
                  // console.log("上传进度", progressData);
                  sessionStorage.setItem(
                    rate,
                    Math.floor(progressData.percent * 100)
                  );
                },
              },
              function (err, data) {
                console.log("视频上传完成", data);
                // console.log(err || data);
                if (err) {
                  console.log("上传出错", err);
                  sessionStorage.setItem(rate, "00");
                  resolve({ status: "fail", error: "上传失败" });
                  return { status: "fail", error: "上传失败" };
                }
                let _url = "https://" + data.Location;
                console.log("地址", _url);
                fetchEndpoint(
                  "/upload/file",
                  "POST",
                  {
                    // url: decodeURI(_url),
                    url: _url, //中文名文件上传获取签名时不做解码处理，解决有空格时获取签名错误的问题(20240129)
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  },
                  false
                ).then((resp) => {
                  // console.log("签名地址", resp);
                  if (resp.code === 0) {
                    if (localStorage[str]) {
                      localStorage.removeItem(str);
                    }
                    sessionStorage.setItem(rate, "000");
                    _url = resp.data.url;
                    resolve({
                      status: "success",
                      response: {
                        opt: {
                          SecretId: resp.data.tmpSecretId,
                          SecretKey: resp.data.tmpSecretKey,
                          pathName: file_name,
                          method: "get",
                          Bucket,
                          Region,
                          token: resp.data.token,
                        },
                        url: resp.data.url,
                        token: resp.data.token,
                        sign: resp.data.sign,
                        waterPath: resp.data.waterUrl,
                        waterSign: resp.data.waterSign,
                      },
                    });
                  } else {
                    sessionStorage.setItem(rate, "00");
                    resolve({ status: "fail", error: resp.msg });
                  }
                });
              }
            );
            return;
          }
          cos.putObject(
            {
              Bucket /* 必须 */,
              Region /* 存储桶所在地域，必须字段 */,
              Key: file_name /* 必须 */,
              // StorageClass: 'STANDARD',
              Body: file, // 上传文件对象
              onProgress: function (progressData) {
                // console.log("上传进度", progressData);
                sessionStorage.setItem(
                  rate,
                  Math.floor(progressData.percent * 100)
                );
                // console.log(JSON.stringify(progressData));
                // let progress =
                //   Number(JSON.stringify(progressData.percent)) * 100;
                // setTimeout(() => {
                //   sessionStorage.setItem(rate, progress);
                // }, 100);
              },
            },
            function (err, data) {
              // console.log(data);
              // console.log(err || data);
              if (err) {
                console.log("上传出错", err);
                resolve({ status: "fail", error: "上传失败" });
                return { status: "fail", error: "上传失败" };
              }
              let _url = "https://" + data.Location;
              console.log("地址", _url);
              // cos.getObjectUrl(
              //   {
              //     Bucket /* 必须 */,
              //     Region /* 存储桶所在地域，必须字段 */,
              //     Key: file_name,
              //     Sign: true /* 必须 */,
              //   },
              //   function (err, data) {
              //     if (err) {
              //       console.log(err);
              //       resolve({ status: "fail", error: "上传失败" });
              //       return { status: "fail", error: "上传失败" };
              //     }
              //   }
              // );
              // return;
              fetchEndpoint(
                "/upload/file",
                "POST",
                {
                  fromArticle: file.fromArticle,
                  // url: decodeURI(_url),
                  url: _url, //中文名文件上传获取签名时不做解码处理，解决有空格时获取签名错误的问题(20240129)
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                },
                false
              ).then((resp) => {
                // console.log("签名地址", resp);
                if (resp.code === 0) {
                  _url = resp.data.url;
                  resolve({
                    status: "success",
                    response: {
                      opt: {
                        SecretId: resp.data.tmpSecretId,
                        SecretKey: resp.data.tmpSecretKey,
                        pathName: file_name,
                        method: "get",
                        Bucket,
                        Region,
                        token: resp.data.token,
                      },
                      url: resp.data.url,
                      token: resp.data.token,
                      sign: resp.data.sign,
                      waterPath: resp.data.waterUrl,
                      waterSign: resp.data.waterSign,
                    },
                  });
                  sessionStorage.setItem(rate, "000");
                } else {
                  sessionStorage.setItem(rate, "00");
                  resolve({ status: "fail", error: resp.msg });
                }
              });
            }
          );
        } else {
          sessionStorage.setItem(rate, "00");
          console.log("res");
          resolve({ status: "fail", error: "上传失败" });
          return { status: "fail", error: "上传失败" };
        }
      },
      (error) => {
        sessionStorage.setItem(rate, "00");
        console.log(error);
        resolve({ status: "fail", error: "上传失败" });
        return { status: "fail", error: "上传失败" };
      }
    );
  });
};
